import React from 'react';

import {
  HStack,
  Header,
  Icon,
  Image,
  Pressable,
  ScrollView,
  VStack,
} from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { BottomSheet } from 'components/bottom-sheet';
import CloseButton from 'components/close-button';
import Dialog from 'components/dialog';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { IconStyled } from '../styled';

import { PickupSelectorProps } from './types';

export const PickupSelector = ({
  isOpen,
  onClose,
  availableServiceModes,
  handleSelectServiceMode,
}: PickupSelectorProps) => {
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  const eventMessage = 'Service mode selector';

  const content = (
    <>
      <HStack
        alignItems="center"
        justifyContent="center"
        paddingY="$3"
        paddingX={isDesktopWeb ? '$0' : '$2'}
        {...(isDesktopWeb && {
          marginBottom: '$6',
        })}
      >
        <Header
          flex={1}
          margin={0}
          paddingLeft="$9"
          fontSize="lg"
          textAlign="center"
          lineHeight="lg"
        >
          {t('serviceModeSelectorTitle')}
        </Header>
        <CloseButton
          testID="service-mode-selector-close-button"
          _svg={{ size: '$5' }}
          onPress={onClose}
          borderRadius={0}
        />
      </HStack>
      <ScrollView showsVerticalScrollIndicator={isDesktopWeb}>
        {availableServiceModes?.map(serviceMode => {
          return (
            <Pressable
              key={serviceMode.name}
              onPress={() => handleSelectServiceMode(serviceMode.name)}
              {...(isDesktopWeb && {
                paddingBottom: '$6',
              })}
            >
              <HStack
                padding="$4"
                alignItems="center"
                borderTopWidth={1}
                borderColor={primitive.$blackOpacity10}
              >
                <Image
                  testID="service-mode-image"
                  source={serviceMode.image}
                  width="$20"
                  height="$20"
                  borderRadius={100}
                />
                <VStack marginLeft="$4" paddingY="$5" flex={1}>
                  <HStack>
                    <IconStyled testID="service-mode-icon" variant={serviceMode.icon} />
                    <VStack flex={1} marginLeft="$1">
                      <Header lineHeight="sm" fontSize="md" margin="$0">
                        {serviceMode.heading}
                      </Header>
                      <Typography fontSize="sm">{serviceMode.description}</Typography>
                    </VStack>
                  </HStack>
                </VStack>
                {serviceMode.isSelected && (
                  <Icon testID="service-mode-check-mark" variant="checkMark" />
                )}
              </HStack>
            </Pressable>
          );
        })}
      </ScrollView>
    </>
  );

  return isDesktopWeb ? (
    <Dialog
      showDialog={isOpen}
      modalAppearanceEventMessage={eventMessage}
      contentMaxWidth="520px"
      onDismiss={onClose}
      bodyComponent={content}
      closeOnOverlayClick
      contentPadding="$4"
    />
  ) : (
    <BottomSheet onOpenEventMessage={eventMessage} isOpen={isOpen} onClose={onClose}>
      <View style={pickupStyles.contentWrapper}>{content}</View>
    </BottomSheet>
  );
};

const pickupStyles = StyleSheet.create({
  contentWrapper: {
    alignItems: 'stretch',
  },
});
